import { createContext } from 'react';
import { Modal, ModalActions } from './types';

export const ModalInitState: Modal = {
  chooseQuote: { isOpen: false, marketActiveQuotes: [] },
};

export const ModalStateContext = createContext<Modal>(ModalInitState);
export const ModalActionsContext = createContext<ModalActions | undefined>(undefined);
